import {useAccountIdSingleVoyage} from "@containers/singleVoyage/account/hooks/useAccountIdSingleVoyage";

export function useGetInitialAccountIdSingleVoyage(): string {
    return useAccountIdSingleVoyage().accountId
}
